class CardLink {
  constructor(element) {
    this.element = element;
    this.link = this.element.querySelector('[data-element="card-link"]');
  }

  init() {
    this.element.addEventListener('click', this.onCardClick.bind(this));
  }

  onCardClick() {
    // Avoid clicking the link when selecting text
    const isTextSelected = !!window.getSelection().toString();
    if (isTextSelected) {
      return;
    }

    this.link.click();
  }
}

const cardLink = {
  init() {
    const cardLinkElements = document.querySelectorAll('[data-module="card-link"]');

    if (cardLinkElements && cardLinkElements.length) {
      cardLinkElements.forEach((element) => {
        const cardLinkElement = new CardLink(element);
        cardLinkElement.init();
      });
    }
  },
};

export default cardLink;
